<template>
  <div class="pie" ref="pie" style="height: 100%"></div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    }
  },
  mounted() {
    this.draw()
  },
  methods: {
    draw() {
      let {
        datas = [{ value: 80, name: '在线' }, { value: 20, name: '离线' }],
        axisData = ['在线', "离线"]
      } = this.data
      var colorList = this.colorList || [
        "#123571", "#1300FF", "#FF6F00", "#0074FF", "#D10CB2", "#08E67C",
        "#FFDA6E",
        "#68E7F9",
        "#7368F9",
        "#FFAD6E",
        "#68AAF9",
        "#68F9B4",
        "#ED6464",
        "#7299FF",
        "#FF9703",
        "#00FF14",
        "#00AAFF",
        "#FFBD00",
        "#FF0062",
        "#67DDA5",
        "#FF00E6",
        "#FFA872",
        "#2DAFC8",
        "#C8C62D",
        "#C8692D",
        "#BD2DC8",
        "#2DC86D",
        "#C82D6F",
        "#68FFC9",
        "#EB72FF",
      ]
      let myChart = this.$echarts.init(this.$refs.pie)
      let option = {

        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}'
        },
        legend: {
          show: false,
          right: '10%',
          top: 0,
          orient: 'vertical',
          data: axisData,
          textStyle: {
            color: '#333333'
          },
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '55%',
            center: ['50%', '40%'],
            data: datas,
            label: {
              position: 'outside',
              formatter: '{b}({d}%)'
            },
            labelLine: {
              length: "1%",
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex]
                }
              },
            },
          }
        ]
      };
      myChart.setOption(option)
      myChart.on('click', this.chartClick)

    },
    chartClick(param) {
      this.$emit('pieClick', param)

    },
  },
}
</script>

<style lang="scss" scope>
.pie {
  & > div:first-child {
    width: 100% !important;
    height: 100% !important;
  }
  canvas {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>

